import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { useActiveFilter } from 'component/Search/Filter/Active/__hooks/useActiveFilter';

import { SearchFormContext } from 'context/SearchFormContext';
import { useSetAtom } from 'jotai';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { filterReset } from 'data/Atom/Component';

import styles from './Reset.module.scss';

const Reset = () => {
    const { t } = useTranslation();
    const { activeFilterList } = useContext(SearchFormContext);
    const { removeAllActiveFilterFromSearch } = useActiveFilter();
    const setIsFilterReset = useSetAtom(filterReset);
    const qaAttr = useQa(QaIdentifier.Search_Filter_Reset);

    const onResetAllClick = useCallback(() => {
        removeAllActiveFilterFromSearch(activeFilterList);
        setIsFilterReset(false);
        setIsFilterReset(true);
    }, [removeAllActiveFilterFromSearch, activeFilterList, setIsFilterReset]);

    if (activeFilterList.length === 0) {
        return null;
    }

    return (
        <div className={styles.Reset} onClick={onResetAllClick} {...qaAttr}>
            <span>{t('TRANS-reset-all-filters')}</span>
        </div>
    );
};

export default Reset;
